import { connect } from "react-redux";
import { FullFormState } from "Engine/src/Engine/Core/Store/FullFormState";

import { withResolvePaths } from "../../../../withResolvePaths";
import { AbsoluteModelPath } from "../../../../../../../Common/ModelPath/ModelPath";

import { MultilinePager } from "./MultilinePager";

export interface MultilinePagerContainerProps {
    bindingPath: AbsoluteModelPath;
    filteredUniqKey?: string;
}

const mapStateToProps = (_: FullFormState, ownProps: MultilinePagerContainerProps) => ({
    filteredUniqKey: ownProps.filteredUniqKey ?? "default",
});

export const MultilinePagerContainer = withResolvePaths(connect(mapStateToProps)(MultilinePager));
